module.exports = __webpack_public_path__ + "static/media/view3.0f2856ba.jpg";